module.exports = __webpack_public_path__ + "img/Sioumazang Yakiniku.90b99a0d.svg";